import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import "./feature.css";
import "./dashboard.css";
import "./fixes.css";
import "./bright-cleaning-style.css";
import "./modern-ui.css";
import "./services-pricing.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
